import Cookies from "js-cookie";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import {FetchSecurityMaster} from '../../api/api'
import { currencyFormat, formateCurr, formateDatabuyCurr, formateDataCurr } from "../../utils/types";

const FundTransfer = () => {
  const [getData, setGetData] = useState<any>()
  const [selectedSector, setSelectedSector] = useState()
  const [getBalance, setGetBalance] = useState<any>(null)
  const [filteredSector, setFilteredSector] = useState<any>()
  const [showErrormsg, setShowErrormsg] = useState(false);
  const [amountValue, setAmountValue] = useState('')
  const selectedClient:any = Cookies.get("client")
  useEffect(() => {
    FetchSecurityMaster("SectorTransferData", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setGetData(response);
      });
  }, []);

  function handleChangeSector(e:any){
    setSelectedSector(e.target.value)
  }

  useEffect(() => {
    setGetBalance(_.filter(getData, {sectorName: selectedSector}))
    setFilteredSector(_.filter(getData, function (f) { return f.sectorID !== getBalance[0]?.sectorID; }))
  }, [getBalance, getData, selectedSector])
  
  function handleAmount(e:any){
    setAmountValue(e.targer.value)
  }

function handleSubmit(e:any){
  e.preventDefault()
  setShowErrormsg(true)
}

  return (
    <div className="mt-4">
      <div className="card mr-2 shadow-none">
      <div className="col-sm-3 w-100 py-3 justify-content-between tableFilters"><h5 className="card-title float-start">Sector Transfer</h5></div>
      {showErrormsg && showErrormsg ? (
          // <span className="errorText text-danger position-absolute" style={{top: "46px", fontSize: "14px"}}>
          //   Total Target % should be equal to 100%, Please enter/adjust the New Target %
          // </span>
          <div
            className="alert alert-success alert-dismissible position-absolute statusAlert"
            role="alert"
          >
            <div className="alert-message">
            Sector Transfer Successfully 
            </div>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
        ) : null}
        <div className="row content-pane">
          
          <div className="col-12 my-3">
            <form id="fundTransferForm" className="tradeForm" onSubmit={handleSubmit}>
              <div className="row">
                <div className="mb-3 col-md-2">
                  <label>Sector (From)</label>
                </div>
                <div className="mb-3 col-md-4 error-placeholder w-25">
                  <select
                    onChange={handleChangeSector}
                    className="form-select"
                  >
                    <option value="">Select</option>
                    {
                      getData && getData.map((e:any)=>{
                        return <option value={e.sectorName} key={e.sectorID}>{e.sectorName}</option>
                      })
                    }
                  </select>
                </div>
                <div className="mb-3 col-md-2 d-flex align-items-center px-6">
                  <label>Balance:</label>
                </div>
                <div className="mb-3 col-md-4 d-flex align-items-center">
                  <strong>
                   
                    {
                    getBalance && getBalance >= 0 ? '$0' :
                    getBalance && getBalance.map((e:any) =>{
                      return  "$" + currencyFormat(e.sectorBalance) 
                    })}
                    </strong>
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-md-2">
                  <label>Sector (To)</label>
                </div>
                <div className="mb-3 col-md-4 error-placeholder w-25">
                  <select
                    name="validation-required"
                    id="targetFund"
                    className="form-control"
                    
                  >
                    <option value="">Select</option>
                    {
                      filteredSector && filteredSector.map((e:any) =>{
                        return  <option value={e.sectorName} key={e.sectorID}>{e.sectorName}</option>
                      })
                    }
                  </select>
                </div>
                <div className="mb-3 col-md-2 px-6">
                  <label>Amount:</label>
                </div>
                <div className="mb-3 col-md-4 error-placeholder">
                  <input
                    name="validation-amount"
                    type="text"
                    className="mb-3 form-control secure-input-field w-50"
                    id="inputAmount"
                    placeholder=""
                    onChange={handleAmount}
                  />
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-md-2">
                  <label>Notes</label>
                </div>
                <div className="mb-3 col-md-4 w-25">
                  <textarea className="form-control" id="inputNotes"></textarea>
                </div>
              </div>
              <div className="row pt-4">
            <div className="float-end text-end">
              <button type="button" className="btn btn-link">
                Cancel
              </button>
              <button type="submit" className="btn btn-primary" disabled={amountValue.length === 0 && getBalance >= 0 ? true : false}>
                Submit
              </button>
            </div>
          </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export { FundTransfer };
